import { of, merge } from 'rxjs';
import { map, switchMap, switchMapTo } from 'rxjs/operators';
import { fromJS } from 'immutable';
import { closeModal$, openTransientModal$ } from './intents';
import { flog } from '@zambezi/caballo-vivo';
export var createModal$ = function createModal$(type, data) {
  return of({
    type: type,
    data: data
  }).pipe(flog("Creating modal of type ".concat(type, " with data ").concat(data)), map(function (_ref) {
    var type = _ref.type,
      data = _ref.data;
    return function (state) {
      return state.set('modal', fromJS({
        data: data,
        type: type
      }));
    };
  }));
};
export var clearModal$ = of(function (state) {
  return state.delete('modal');
}).pipe(flog('Clearing modal'));
export var simpleModal$ = merge(openTransientModal$.pipe(switchMap(function (_ref2) {
  var type = _ref2.type,
    data = _ref2.data;
  return createModal$(type, data);
})), closeModal$.pipe(switchMapTo(clearModal$)));